import React from 'react';
import { Box, IconButton, TableCell, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import MoreIcon from '@mui/icons-material/MoreVert';

interface Props {
	label: string;
	filterCount: number;
	setAnchorEl: (el: HTMLElement) => void;
	renderFilter: () => React.ReactNode;
}

const FilterCell = ({ label, filterCount, setAnchorEl, renderFilter }: Props) => {
	const classes = useStyles();
	return (
		<TableCell>
			<Box display="flex" alignItems="center">
				<Box mr={1}>{label}</Box>
				<Box mr={1} width={20}>
					{!!filterCount && (
						<Box className={classes.filterCount}>
							<Typography variant="caption">{filterCount}</Typography>
						</Box>
					)}
				</Box>
				<IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
					<MoreIcon fontSize="small" />
				</IconButton>
				{renderFilter()}
			</Box>
		</TableCell>
	);
};

const useStyles = makeStyles((theme) =>
	createStyles({
		filterCount: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			borderRadius: '50%',
			height: 20,
			width: 20,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
	}),
);

export default FilterCell;
